module.exports = __webpack_public_path__ + "static/full02-662912323db796f20bfb70b1510623a9.png";